import { z } from 'zod';
import { PRICEBOOK_KIND } from '../enums.js';
import { EntityMetaSchema, zCents, zEnum, zNonEmpty } from './common.js';

export const PricebookItemSchema = EntityMetaSchema.extend({
  kind: zEnum(PRICEBOOK_KIND),
  name: zNonEmpty.max(200),
  sku: z.string().max(80).optional(),
  category: z.string().max(80).default('General'),
  description: z.string().max(2000).optional(),
  unitCostCents: z.number().int().min(0).default(0),
  salePriceCents: zCents,
  taxable: z.boolean().default(true),
  active: z.boolean().default(true),
  imageKey: z.string().optional(),
  unit: z.string().max(20).optional(), // "each", "hour", "sq ft"
});
export type PricebookItem = z.infer<typeof PricebookItemSchema>;

export const CreatePricebookItemSchema = z.object({
  kind: zEnum(PRICEBOOK_KIND),
  name: zNonEmpty.max(200),
  sku: z.string().max(80).optional(),
  category: z.string().max(80).optional(),
  description: z.string().max(2000).optional(),
  unitCostCents: z.number().int().min(0).optional(),
  salePriceCents: zCents,
  taxable: z.boolean().optional(),
  active: z.boolean().optional(),
  unit: z.string().max(20).optional(),
});
export type CreatePricebookItemInput = z.infer<typeof CreatePricebookItemSchema>;
export const UpdatePricebookItemSchema = CreatePricebookItemSchema.partial();
export type UpdatePricebookItemInput = z.infer<typeof UpdatePricebookItemSchema>;

/** One row of a CSV import; validated per-row with a per-row error report. */
export const PricebookCsvRowSchema = z.object({
  kind: zEnum(PRICEBOOK_KIND),
  name: zNonEmpty.max(200),
  sku: z.string().max(80).optional(),
  category: z.string().max(80).optional(),
  unitCost: z.coerce.number().min(0).optional(),
  salePrice: z.coerce.number(),
  taxable: z.coerce.boolean().optional(),
  unit: z.string().max(20).optional(),
});
export type PricebookCsvRow = z.infer<typeof PricebookCsvRowSchema>;
